import FPVue from "../../FP.vue";

export default FPVue.extend({
  props: {
    show: { type: Boolean, default: false },
    apiKey: { type: String, default: "" }
  },
  computed: {
    showApiKeyDialog: {
      get(): boolean {
        return this.show;
      },
      set(val: boolean) {
        this.$emit("update:show", val);
      }
    },
    apiKeyValue: {
      get(): string {
        return this.apiKey;
      },
      set(val: string) {
        this.$emit("update:apiKey", val);
      }
    }
  },
  methods: {
    closeDialog() {
      this.showApiKeyDialog = false;
    }
  }
});

